export const LOGIN_PAGE = '/login' // 로그인 페이지
export const MAIN_PAGE = '/' // 메인
export const MAIN_TEMP_PAGE = '/main' // 메인
export const HAPPY_PICK_LIST_PAGE = '/happy_list' // 행복픽 리스트
export const HAPPY_PICK_MANAGEMENT_PAGE = '/happy_mng' // 행복픽 관리
export const CUSTOM_PICK_MANAGEMENT_PAGE = '/custom_mng' // 커스텀픽 관리
export const STORE_MANAGEMENT_PAGE = '/store_mng' // 지점 관리